"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnEscape = void 0;
const react_1 = require("react");
const useOnEscape = (handler, isActive = true) => {
    (0, react_1.useEffect)(() => {
        const handleEscape = (e) => {
            if (handler && e.key === 'Escape') {
                handler(e);
            }
        };
        if (isActive) {
            document.addEventListener('keydown', handleEscape);
        }
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [handler, isActive]);
};
exports.useOnEscape = useOnEscape;
//# sourceMappingURL=index.js.map